import type { TemplateAssignmentEntryPayload } from '@Application/Documents/TemplateAssignments/Actions/templateAssignmentsFetched';

/**
 * Immutable View: `readonly` properties, frozen at the end of the constructor.
 * `documentTypeId` is read off the `documentType` relation (`{ id }`); the label is resolved
 * against `DocumentTypesListView.labelOf`, never carried here. `scopeType` is not on the wire: the
 * API response never repeats the level it was read at, so it is recopied here from the action that
 * carries the scope (`Application/Documents/TemplateAssignments/TemplateAssignmentScope`).
 * `inheritedTemplateId` is always `null` when `scopeType === 'organization'` — only a facility scope
 * inherits from above.
 */
class TemplateAssignmentView {
	readonly documentTypeId: number;
	readonly templateId: number | null;
	readonly inheritedTemplateId: number | null;
	readonly appliedTemplateId: number | null;
	readonly scopeType: 'organization' | 'facility';

	constructor(payload: TemplateAssignmentEntryPayload, scopeType: 'organization' | 'facility') {
		this.documentTypeId = payload.documentType.id;
		this.templateId = payload.template === null ? null : payload.template.id;
		this.inheritedTemplateId = payload.inheritedTemplate === null ? null : payload.inheritedTemplate.id;
		this.appliedTemplateId = payload.appliedTemplate === null ? null : payload.appliedTemplate.id;
		this.scopeType = scopeType;

		Object.freeze(this);
	}

	/** A facility-scoped entry that carries its own `template`, rather than only inheriting one. */
	get isOverride(): boolean {
		return this.scopeType === 'facility' && this.templateId !== null;
	}
}

export default TemplateAssignmentView;
